var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 34,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5536,
    y: 6.7998,
    width: 22.568,
    height: 20.4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4622 23.2806V9.65187C26.8146 11.9285 30.96 14.1277 35.8628 16.4988C31.8191 18.526 26.8146 20.8005 21.4622 23.2806ZM51.2911 2.87369C50.3678 1.77413 48.7942 0.918215 47.1189 0.63485C42.1947 -0.210414 11.4747 -0.212818 6.55318 0.63485C5.20973 0.862504 4.01344 1.41278 2.98578 2.26773C-1.34431 5.90063 0.0125365 25.3827 1.05625 28.5385C1.49515 29.9045 2.06252 30.8896 2.77707 31.5363C3.69768 32.3912 4.95815 32.9799 6.40597 33.2439C10.4604 34.0019 31.3481 34.4258 47.0333 33.3577C48.4784 33.13 49.7576 32.5224 50.7665 31.6311C54.7701 28.0128 54.4972 7.43661 51.2911 2.87369Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt_icon.9935c3fc16afc0b9e357de038f979200.svg";
export { ForwardRef as ReactComponent };